import { ColRowStyle, ColRowStyles } from './ColRowStyle';
import { BaseModel } from './baseModel';
import type { CellStyle } from './cellStyle';
import type { BaseStyle, Unit } from './types';

export class Col extends BaseModel {
  public widthOr(defaultValue: number): number {
    if (typeof this.width === 'number') {
      return this.width;
    }
    return defaultValue;
  }

  constructor(
    public readonly index: number,
    public readonly width: Unit = 'auto',
    public readonly style: ColRowStyles = new ColRowStyles(),
  ) {
    super();
  }

  public withWidth(width: Unit): Col {
    return new Col(this.index, width, this.style);
  }

  public withStyle(style: ColRowStyle): Col {
    return new Col(this.index, this.width, this.style.withStyle(style));
  }

  public cellStyleAt(index: number): BaseStyle<CellStyle> {
    return this.style.cellStyleAt(index);
  }
}
